import "./CsvDownloader.scss";

import { Button, Form } from "@flick/fep-library";
import { DateInput } from "components/Inputs/DateInput";
import { format } from "date-fns";
import React from "react";
import { useAppSelector } from "reduxUtils/hook";
import {
  selectInputForBillingEntityDateRange,
  selectTextForBillingEntityDateRange,
} from "selectors/billingEntitySelector";

import { useCsvDownloaderContext } from "./CsvDownloaderContext";

/**
 * @description CSV download component
 */
export const CsvDownloaderContent: React.FC = () => {
  const {
    startDate: {
      fieldValue: { value: startDateValue, error: startDateError },
      handleOnChange: setStartDateValue,
      handleOnBlur: startDateValueBlur,
    },
    endDate: {
      fieldValue: { value: endDateValue, error: endDateError },
      handleOnChange: setEndDateValue,
      handleOnBlur: endDateValueBlur,
    },
    handleClick,
    isDownloading,
  } = useCsvDownloaderContext();

  const {
    startAtDate: billingEntityStartAtInput,
    endAtDate: billingEntityEndAtInput,
  } = useAppSelector(selectInputForBillingEntityDateRange);

  const {
    startAtDate: billingEntityStartAtText,
    endAtDate: billingEntityEndAtText,
  } = useAppSelector(selectTextForBillingEntityDateRange);

  return (
    <div>
      <p className="section-sub-title">
        Download your half-hour usage information
      </p>
      <Form
        data-validate
        data-synthetic-submit
        onSubmit={handleClick}
        noValidate
      >
        <DateInput
          label="Start date"
          name="startAt"
          required={true}
          value={startDateValue}
          max={billingEntityEndAtInput}
          min={billingEntityStartAtInput}
          handleDateChange={setStartDateValue}
          handleOnBlur={startDateValueBlur}
          errorMessage={startDateError}
        />

        <DateInput
          label="End date"
          name="endAt"
          required={true}
          value={endDateValue}
          max={billingEntityEndAtInput}
          min={
            startDateValue
              ? format(new Date(startDateValue), "yyyy-MM-dd")
              : billingEntityStartAtInput
          }
          handleDateChange={setEndDateValue}
          handleOnBlur={endDateValueBlur}
          errorMessage={endDateError}
        />
        <Button
          type="submit"
          extraClasses="button--expanded"
          disabled={
            !startDateValue ||
            !endDateValue ||
            !!startDateError ||
            !!endDateError ||
            isDownloading
          }
        >
          Download
        </Button>
        <p className="small spacer">
          We have data available for you between {billingEntityStartAtText} and{" "}
          {billingEntityEndAtText}.
        </p>
      </Form>
    </div>
  );
};
